<nz-modal
  [nzVisible]="isVisible()"
  nzTitle="Fleet Client Details"
  [nzFooter]="modalFooter"
  (nzOnOk)="handleSave()"
  (nzOnCancel)="handleCancel()"
  nzWidth="80%">
  <ng-container *nzModalContent>
    @if (isLoading()) {
      <div style="text-align: center; padding: 48px 0;">
        <nz-spin nzSize="large"></nz-spin>
      </div>
    } @else {
    <!-- ROW 1: Form fields -->
    <nz-row [nzGutter]="24">
      <nz-col nzSpan="12">
        <form nz-form [formGroup]="form" nzLayout="vertical">
          <h3>Fleet Information</h3>
          <nz-form-item>
            <nz-form-label nzRequired>Fleet Client Name</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldErrorMessage('clientName')" [nzValidateStatus]="isFieldInvalid('clientName') ? 'error' : ''">
              <input nz-input formControlName="clientName" placeholder="Enter fleet client name"/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label>Phone</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldErrorMessage('clientTel')" [nzValidateStatus]="isFieldInvalid('clientTel') ? 'error' : ''">
              <input nz-input formControlName="clientTel" placeholder="Enter fleet client phone number"/>
            </nz-form-control>
          </nz-form-item>
        </form>
      </nz-col>
      <nz-col nzSpan="12">
        <form nz-form [formGroup]="form" nzLayout="vertical">
          <h3>Operator</h3>
          <nz-form-item>
            <nz-form-label>Operator Name</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldErrorMessage('operatorName')" [nzValidateStatus]="isFieldInvalid('operatorName') ? 'error' : ''">
              <input nz-input formControlName="operatorName" placeholder="Enter operator name"/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label>Operator Contact Number</nz-form-label>
            <nz-form-control [nzErrorTip]="getFieldErrorMessage('operatorCell')" [nzValidateStatus]="isFieldInvalid('operatorCell') ? 'error' : ''">
              <input nz-input formControlName="operatorCell" placeholder="Enter operator phone number"/>
            </nz-form-control>
          </nz-form-item>
        </form>
      </nz-col>
    </nz-row>
    <!-- ROW 2: Pricing template & WA Group Link -->
    <nz-row [nzAlign]="'bottom'">
      <form nz-form [formGroup]="form" nzLayout="vertical" style="width: 100%;">
        <nz-row [nzGutter]="24">
          <nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label nzRequired>Pricing Template</nz-form-label>
              <nz-form-control [nzErrorTip]="getFieldErrorMessage('pricingMethodId')" [nzValidateStatus]="isFieldInvalid('pricingMethodId') ? 'error' : ''">
                <nz-select formControlName="pricingId" nzPlaceHolder="Select a pricing template" style="width: 100%;">
                  @for (template of pricingTemplates(); track template.pricingTemplateId) {
                    <nz-option [nzValue]="template.pricingTemplateId" [nzLabel]="template.pricingName"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label>WhatsApp Group Link</nz-form-label>
              <nz-form-control [nzErrorTip]="getFieldErrorMessage('whatsappGroupLink')" [nzValidateStatus]="isFieldInvalid('whatsappGroupLink') ? 'error' : ''">
                <input nz-input formControlName="whatsappGroupLink" placeholder="Enter WhatsApp group link for this fleet" appWaGroupLink (groupNameResolved)="onGroupNameResolved($event)" (loadingChange)="onGroupLoadingChange($event)"/>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>WhatsApp Group Name</nz-form-label>
              <nz-form-control>
                <ng-template #loadingSuffix>
                  @if (isLoadingGroupName()) {
                    <nz-icon nzType="loading"></nz-icon>
                  }
                </ng-template>
                <nz-input-group [nzSuffix]="loadingSuffix">
                  <input nz-input formControlName="whatsappGroupName" placeholder="Group name (auto-filled from link)"/>
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>
      </form>
    </nz-row>


    <!-- ROW 3: Tables -->
     @if (selectedFleet()) {
      <nz-row [nzGutter]="24" style="margin-top: 24px;">
        <nz-col nzSpan="12">
          <h3>Drivers</h3>
          <nz-table [nzData]="drivers()"
            nzSize="small"
            [nzShowPagination]="false"
            [nzBordered]="true"
            [nzNoResult]="noDrivers"
            [nzScroll]="{ y: '20vh' }"
            [nzFrontPagination]="false"
            [nzWidthConfig]="['45%', '45%', '10%']">
            <thead>
              <tr>
                <th style="width: 45%;">Name</th>
                <th style="width: 45%;">Phone</th>
                <th style="width: 10%;"></th>
              </tr>
            </thead>
            <tbody>
              @for (driver of drivers(); track $index) {
                <tr>
                  <td>{{ driver.name }}</td>
                  <td>{{ driver.phoneNumber }}</td>
                  <td>
                    <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeDriver(driver.driverId)">
                      <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
                    </button>
                  </td>
                </tr>
              }
              <ng-template #noDrivers>
                <tr style="text-align:center; color:#8c8c8c;">No drivers added</tr>
              </ng-template>
            </tbody>
          </nz-table>
          <nz-row [nzGutter]="8" style="margin-top: 8px;">
            <form [formGroup]="newDriverForm" style="display: contents;">
              <nz-col nzSpan="10">
                <input nz-input formControlName="name" placeholder="Driver name"/>
              </nz-col>
              <nz-col nzSpan="10">
                <input nz-input formControlName="phone" placeholder="Phone number"/>
              </nz-col>
              <nz-col nzSpan="4">
                <button nz-button nzType="dashed" (click)="addDriver()" 
                  [disabled]="newDriverForm.get('name')?.value?.trim() === '' || newDriverForm.get('phone')?.value?.trim() === ''" 
                  style="width:100%">
                  <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
                </button>
              </nz-col>
            </form>
          </nz-row>
        </nz-col>

        <nz-col nzSpan="12">
          <h3>Vehicles</h3>
          <nz-table [nzData]="vehicles()"
          nzSize="small"
            [nzShowPagination]="false"
            [nzBordered]="true"
              [nzNoResult]="noVehicles"
              [nzScroll]="{ y: '20vh' }"
                [nzFrontPagination]="false"
                [nzWidthConfig]="['45%', '45%', '10%']">
            <thead>
              <tr>
                <th>Registration</th>
                <th>VIN</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (vehicle of vehicles(); track $index) {
                <tr>
                  <td>{{ vehicle.registrationNumber }}</td>
                  <td>{{ vehicle.vinNumber || '—' }}</td>
                  <td>
                    <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeVehicle(vehicle.vehicleId)">
                      <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
                    </button>
                  </td>
                </tr>
              }
              <ng-template #noVehicles>
                <tr><td colspan="3" style="text-align:center; color:#8c8c8c;">No vehicles added</td></tr>
              </ng-template>
            </tbody>
          </nz-table>
          <nz-row [nzGutter]="8" style="margin-top: 8px;">
            <form [formGroup]="newVehicleForm" style="display: contents;">
              <nz-col nzSpan="10">
                <input nz-input formControlName="registration" placeholder="Registration"/>
              </nz-col>
              <nz-col nzSpan="10">
                <input nz-input formControlName="vin" placeholder="VIN (optional)"/>
              </nz-col>
              <nz-col nzSpan="4">
                <button nz-button nzType="dashed" (click)="addVehicle()" 
                  [disabled]="newVehicleForm.get('registration')?.value?.trim() === ''" 
                  style="width:100%">
                  <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
                </button>
              </nz-col>
            </form>
          </nz-row>
        </nz-col>
      </nz-row>
    }
    @else {
      <div style="padding: 8px; background-color: #fafafa; border: 1px solid #d9d9d9; border-radius: 2px; text-align: center; margin-top: 24px;">
        <p style="margin: 0; color: #8c8c8c; font-size: 14px;">Please save fleet before adding vehicles and drivers</p>
      </div>
    }
  }
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    @if (additionalFleets().length > 0) {
    <button nz-button nzType="primary" (click)="handleMerge()" [nzLoading]="isLoading()" [disabled]="form.invalid">
      Merge Fleets
    </button>
  } @else {
    <button nz-button nzType="primary" (click)="handleSave()" [nzLoading]="isLoading()" [disabled]="form.invalid">
      Save
    </button>
  }
  </ng-template>

</nz-modal>